import { addDoc, deleteDoc, doc, getDoc, getDocs, query, updateDoc, where } from 'firebase/firestore';
import { isSavedOrderV2, SavedOrder, savedOrdersRef } from '@api/SavedOrders/SavedOrder';
import UserServ from '@api/Users/UserServ';
import { ShoppingCart } from '@api/ShoppingCart/ShoppingCart';
import { ShoppingCartV2 } from '@api/ShoppingCart/ShoppingCartV2';
import { SalesChannel } from '@api/SalesChannels/SalesChannel';
import store from '@store/index';
export default {
    async saveSavedOrder(
        shoppingCart: ShoppingCart | ShoppingCartV2,
        savedOrderId?: string,
        salesChannel?: SalesChannel,
        schemaVersion?: 2
    ): Promise<SavedOrder> {
        const user = await UserServ.getUser();
        const savedOrder: SavedOrder = {
            id: savedOrderId,
            shoppingCart,
            userId: user.uid,
            branchOfficeId: store.getState().auth.branchOfficeSelected?.id,
            salesChannel,
            schemaVersion
        };
        if (!savedOrder.id) {
            const data = await addDoc(savedOrdersRef, savedOrder);
            savedOrder.id = data.id;
        }
        await updateDoc(doc(savedOrdersRef, savedOrder.id), { ...savedOrder });
        return savedOrder;
    },
    // Sin `schemaVersion` regresa SOLO carritos v1 (docs sin el campo); con 2,
    // SOLO carritos del POS 2.0. Filtrado en cliente: Firestore no consulta
    // "campo ausente" y los docs viejos no traen schemaVersion.
    /**
     * Los carritos estacionados de la sucursal en operación.
     *
     * Limpieza v1 (2026-08-19): antes recibía `schemaVersion` para que cada POS
     * listara los suyos. Ya solo hay UN POS (el 2.0) y los 19 docs v1 se purgaron,
     * así que el parámetro era un footgun: llamar sin él devolvía SOLO los v1, es
     * decir, nada. Ahora siempre devuelve los v2 y punto.
     */
    async getSavedOrders(): Promise<SavedOrder[]> {
        const savedOrders: SavedOrder[] = [];
        const branchOfficeId = store.getState().auth.branchOfficeSelected?.id;
        const queryDoc = query(savedOrdersRef, where('branchOfficeId', '==', branchOfficeId));
        const snapshot = await getDocs(queryDoc);
        if (snapshot.empty) {
            return savedOrders;
        }
        snapshot.docs.map((doc: any) => {
            savedOrders.push(doc.data() as SavedOrder);
        });
        return savedOrders.filter(isSavedOrderV2);
    },
    async getSavedOrder(savedOrderId: string): Promise<SavedOrder> {
        const documentData = await getDoc(doc(savedOrdersRef, savedOrderId));
        return documentData.data() as SavedOrder;
    },
    async deleteSavedOrder(savedOrderId: string): Promise<void> {
        await deleteDoc(doc(savedOrdersRef, savedOrderId));
        return;
    }
};
